/**
 * Verifica rescursivamente as propriedades do tipo Date para criar novas instâncias no retorno
 * @param {*} origem Objeto original a ser copiado
 * @param {*} copia Objeto que será retornado pela função
 */
function copiaDateTime(origem, copia) {
    //Percorre as propriedades
    for (const key in origem) {
        //Caso seja do tipo Date, realiza a conversão
        if (origem[key] instanceof Date)
            copia[key] = new Date(origem[key].getTime());
        //Caso seja um objeto aninhado, percorre as propriedades do mesmo
        else if (origem[key] instanceof Object)
            copiaDateTime(origem[key], copia[key]);
    }
}

/**
 * Realiza a cópia de todas as propriedades de um objeto para um novo
 * A cópia é realizada mesmo para propriedades aninhadas
 * Os tipos das cópias são os mesmos, inclusive Date
 * @param {*} origem Objeto que será copiado
 * @returns {*} Retorna a cópia do objeto
 */
function deepCopy(origem) {
    //Caso for uma data, retorna a cópia pronta
    if (origem instanceof Date) 
        return new Date(origem.getTime());
    else { //Caso contrário realiza a cópia convertendo para JSON e de volta para objeto
        const copia = JSON.parse(JSON.stringify(origem));
        //Verifica as propriedades do tipo DateTime
        copiaDateTime(origem, copia);
        //Retorna a cópia
        return copia;
    }
}

export default deepCopy;